
<form [formGroup]="group">
    <bt-numeric-textbox-form
        [formControlName]="model.id"
        [model]="model"
        [value]="model.value"
        [required]="model.required"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)">
    </bt-numeric-textbox-form>
</form>